export default __webpack_public_path__ + "static/media/Cold Drinks & Juices.5fee1f4d.png";